import React from 'react';
import { useNavigate } from 'react-router-dom';

const ComingSoonPage = ({ title, message }) => {
  const navigate = useNavigate();

  return (
    <div className="container py-4" style={{ maxWidth: 640 }}>
      <div className="d-flex align-items-center mb-3">
        <button type="button" className="btn btn-light rounded-circle me-3" style={{ width: 40, height: 40 }} onClick={() => navigate(-1)}>
          <span className="material-symbols-outlined">arrow_back</span>
        </button>
        <h3 className="mb-0">{title}</h3>
      </div>
      <div className="card">
        <div className="card-body text-center py-5">
          <span className="material-symbols-outlined" style={{ fontSize: 48, color: '#D85A30' }}>hourglass_empty</span>
          <h5 className="mt-3">Coming soon</h5>
          <p className="text-muted mb-0">
            {message || "This feature isn't available yet. Check back soon."}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonPage;
